import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import React from 'react';

const GlobalStructuredData = ({ name, url }) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        name,
        url,
      })}
    </script>
  </Helmet>
);

GlobalStructuredData.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default GlobalStructuredData;
